import { useCallback, useMemo } from "react";
import { IndexedDBService } from "../services/indexedDbService";



export const useCreditPaymentIDB = () => {
    const db = useMemo(() => new IndexedDBService(), []);

    const saveCreditPayment = useCallback(
        async ({ id, amount, hasExtend, dateExtend }) => {
            const record = {
                id,
                amount,
                hasExtend,
                dateExtend,
                updatedAt: Date.now(),
            };

            // put/add según tu servicio
            await db.addItem(record);
            return record;
        },
        [db]
    );

    const getCreditPayment = useCallback(async (creditId) => {
        try {
            const item = await db.getItemById(creditId);
            return item || null;
        } catch (error) {
            console.error("Error getting credit payment from IndexedDB:", error);
            return null;
        }
    }, [db]);

    const updateCreditPayment = useCallback(
        async (creditId, partialData) => {
            try {
                const current = await db.getItemById(creditId);
                if (!current) return null;

                const updated = {
                    ...current,
                    ...partialData,
                    updatedAt: Date.now(),
                };

                await db.updateItem(creditId, updated);
                return updated;
            } catch (error) {
                console.error("Error updating credit payment in IndexedDB:", error);
                return null;
            }
        },
        [db]
    );

    const deleteCreditPayment = useCallback(async (creditId) => {
        try {
            await db.deleteItem(creditId);
            return true;
        } catch (error) {
            console.error("Error deleting credit payment from IndexedDB:", error);
            return false;
        }
    }, [db]);

    const getAllCreditPayments = useCallback(async () => {
        try {
            return await db.getAllItems();
        } catch (error) {
            console.error("Error getting all credit payments:", error);
            return [];
        }
    }, [db]);

    /**
     * Utilidad específica para tu caso actual:
     * - Busca por credit_id (key real del store)
     * - Si no existe, lo crea
     */
    const ensureCreditPaymentExists = useCallback(
        async ({ id, amount, hasExtend, dateExtend }) => {
            let item = await db.getItemById(id);

            if (!item) {
                item = await saveCreditPayment({ id, amount, hasExtend, dateExtend });
            } else {
                // Si ya existe, actualizar el item
                item = await updateCreditPayment(id, { amount, hasExtend, dateExtend });
            }

            return item;
        },
        [db, saveCreditPayment, updateCreditPayment]
    );

    return {
        saveCreditPayment,
        getCreditPayment,
        updateCreditPayment,
        deleteCreditPayment,
        getAllCreditPayments,
        ensureCreditPaymentExists,
    };
};
